import { useMutation } from "@apollo/client";
import { Button, MenuItem } from "@blueprintjs/core";
import { Tooltip2 } from "@blueprintjs/popover2";
import { IItemRendererProps, ItemRenderer, Select2 } from "@blueprintjs/select";
import _ from "lodash";
import { useState } from "react";
import {
  Article,
  ArticleParameter,
  CreateArticleParameterInput,
  KeyField,
  KeyField_Type,
} from "../../../../api/schema";
import { CreateVariables } from "../../../../components/form/InputForm";
import { UserLanguage } from "../../../../lang/lang";
import { _p } from "../../../../utils/pack";
import { CreateArticleParameterMutation } from "../../helper/graphql";

interface NewParameterProps {
  article: Article;
  on_created: () => void;
}

const KeyFieldRenderer =
  (
    create_field: (f: KeyField) => Promise<any>,
    props: NewParameterProps
  ): ItemRenderer<KeyField> =>
  (item: KeyField, itemProps: IItemRendererProps) => {
    return (
      <MenuItem
        key={item.id}
        text={_.get(UserLanguage().data.fields, item.name, item.name)}
        onClick={() => create_field(item).then(() => props.on_created())}
      />
    );
  };

export const NewParameter = (props: NewParameterProps) => {
  const [create_parameter] = useMutation<
    ArticleParameter,
    CreateVariables<CreateArticleParameterInput>
  >(CreateArticleParameterMutation);

  const [fixing, set_fixing] = useState(false);

  const article = props.article;
  const ac = article.article_category;

  let missing: KeyField[] = [];
  let missing_required: KeyField[] = [];

  if (ac) {
    const key_fields = ac.fields;
    console.log("key_fields in ac", key_fields);

    const article_fields = article.fields;
    missing = _(key_fields)
      .filter((kf) => !_.find(article_fields, { key_field: { id: kf.id } }))
      .value();

    missing_required = _.filter(missing, (f) => f.required);

    console.log(missing, missing_required);
  }

  const create_field = async (field: KeyField) =>
    _p(console.log("Creating new field", field)).then(() => {
      let suffix = "";
      if (field.type === KeyField_Type.float && field.values.length > 0)
        suffix = field.values[0];

      return create_parameter({
        variables: {
          values: {
            article_id: props.article.id,
            key_field_id: field.id,
            suffix: suffix,
            value: "",
          },
        },
      });
    });

  const fix_missing = () => {
    set_fixing(true);
    Promise.all(_.map(missing, create_field))
      .then(() => set_fixing(false))
      .then(() => props.on_created());
  };

  console.log("missing fields", missing);

  if (missing.length > 0) {
    return (
      <div style={{ display: "flex", gap: 15 }}>
        {missing_required.length > 0 ? (
          <Tooltip2
            intent="danger"
            content={
              UserLanguage().pages.article.parameter.fix_required_tooltip
            }
          >
            <Button
              icon="edit"
              intent="danger"
              text={UserLanguage().pages.article.parameter.fix_required}
              onClick={fix_missing}
              disabled={fixing}
            />
          </Tooltip2>
        ) : (
          <></>
        )}
        <Select2<KeyField>
          items={missing}
          itemRenderer={KeyFieldRenderer(create_field, props)}
          onItemSelect={() => {}}
        >
          <Button
            rightIcon="chevron-down"
            text={UserLanguage().actions.add}
            disabled={fixing}
          />
        </Select2>
      </div>
    );
  } else {
    return <Button icon="plus" />;
  }
};
